import { render } from "./LotStatusPrice.vue?vue&type=template&id=6d3f62c1&scoped=true&ts=true&lang=pug"
import script from "./LotStatusPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotStatusPrice.vue?vue&type=script&lang=ts&setup=true"

import "./LotStatusPrice.vue?vue&type=style&index=0&id=6d3f62c1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3f62c1"]])

export default __exports__